import { useParams } from 'react-router-dom';
import { dateFieldForCategory } from '../constants';
export function useDateFieldForCategory() {
  const {
    category
  } = useParams();
  return category ? dateFieldForCategory[category] : 'stageDate';
}